var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useMemo } from 'react';
import { XFormInputContainer } from './XFormInputContainer';
import { XButton } from '../button/XButton';
import { XDialog } from '../dialog/XDialog';
import { XSection } from '../section/XSection';
import { XSectionHeader } from '../section/XSectionHeader';
import countries from '../../../data/countries.json';
import { useForm } from '../../hooks/useForm';
import { XBox, XText } from '../..';
export function XFormInputPhone(input) {
    var _a = input.value, areaCode = _a.areaCode, phone = _a.phone;
    var _b = useState(false), isAreaCodeOpen = _b[0], setIsAreaCodeOpen = _b[1];
    var form = useForm({
        keyword: {
            type: 'text',
            value: '',
            placeholder: 'Type to search',
        },
    });
    function handleChange(value) {
        var _a;
        (_a = input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, __assign({ areaCode: areaCode,
            phone: phone }, value));
    }
    var keyword = form.getData().keyword;
    var countriesFiltered = useMemo(function () {
        return countries.filter(function (country) {
            return country.name.toLowerCase().includes((keyword || '').toLowerCase()) ||
                country.number.toLowerCase().includes((keyword || '').toLowerCase());
        });
    }, [keyword]);
    return (React.createElement(React.Fragment, null,
        React.createElement(XFormInputContainer, __assign({}, input, { className: 'XFormInputPhone', adornmentStart: React.createElement(XButton, { onClick: function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    setIsAreaCodeOpen(!isAreaCodeOpen);
                }, variant: 'text' },
                "+",
                areaCode) }),
            React.createElement("input", __assign({}, input, { type: 'tel', value: phone !== null && phone !== void 0 ? phone : '', onChange: function (event) {
                    handleChange({
                        phone: event.target.value,
                    });
                } }))),
        isAreaCodeOpen && (React.createElement(XDialog, { onClose: function () { return setIsAreaCodeOpen(false); }, header: React.createElement(XSectionHeader, { title: 'Choose country', buttonsElement: React.createElement(XButton, { onClick: function () { return setIsAreaCodeOpen(false); }, icon: 'close' }) }) },
            React.createElement(XSection, null, form.getInputElement('keyword')),
            React.createElement(XSection, null, countriesFiltered.map(function (country) { return (React.createElement(XButton, { key: country.name, fullWidth: true, variant: 'text' },
                React.createElement(XBox, { onClick: function () {
                        setIsAreaCodeOpen(false);
                        handleChange({
                            areaCode: country.number.replace('+', ''),
                        });
                    }, fullWidth: true, flex: true, justify: 'space-between' },
                    React.createElement("div", null, country.name),
                    React.createElement(XText, { color: "text-secondary" }, country.number)))); }))))));
}
